/** @file slotIndexOf: every slot by key with the entry that owns it, derived once (slot.fillMany). */
import { deriveSlots } from '@zilo/pose3d-format/derive/deriveSlots';
import type { FacetEntry, ImageSlot } from '@zilo/pose3d-format/types/facet';
import type { Puppet } from '@zilo/pose3d-format/types/puppet';

/** Slot key -> `{ slot, entry }` for the impostor slots `deriveSlots` lists (the entry is the live draft object). */
export function slotIndexOf(puppet: Puppet): Map<string, { slot: ImageSlot; entry: FacetEntry }> {
  const out = new Map<string, { slot: ImageSlot; entry: FacetEntry }>();
  for (const slot of deriveSlots(puppet)) {
    const d = puppet.drawables.find((x) => x.id === slot.drawable);
    const entry = d?.kind === 'impostor' ? d.facets[slot.entry] : undefined;
    if (entry !== undefined) out.set(slot.key, { slot, entry });
  }
  return out;
}
